import routes from "@app/config/routes";
import { useDeliveryData } from "@app/store/useDeliverySearchData";
import { Box, Card, Flex, Group, Text, Title, Tooltip } from "@mantine/core";
import { IconChevronLeft, IconMedicineSyrup, IconPills } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { confirmNotification, warningNotification } from "@app/common/components/notifications";
import { useGetPatientInformation } from "@app/services/common/hooks";

import "./styles.scss";

export default function SelectionDelivery() {
  const navigate = useNavigate();

  const { setDataDispense, dataDispense } = useDeliveryData();
  const { dataPatient } = useDeliveryData((state) => state.dataToSearch);

  const { refetch: refetchPatientInformation, isFetching: isFetchingPatientInformation } =
    useGetPatientInformation(
      {
        id: dataPatient?.id
      },
      false
    );

  const handleParticularDelivery = async () => {
    if (isFetchingPatientInformation) {
      return;
    }

    if (!dataPatient?.id) {
      warningNotification(
        "No se pudo identificar al paciente para validar su contrato particular."
      );
      return;
    }

    const patientInformationResponse = await refetchPatientInformation();
    const hasParticularContract = patientInformationResponse.data?.results?.contracts?.some(
      (contract) => contract.companyTypeTag?.toLowerCase() === "particular"
    );

    if (!hasParticularContract) {
      warningNotification(
        "No es posible realizar la entrega, el paciente no cuenta con un contrato particular relacionado."
      );
      return;
    }

    confirmNotification(
      "Este medicamento será dispensado por venta libre. ¿Desea continuar con la dispensación?",
      undefined,
      () => {
        navigate(routes.getDeliveryDispensation);
        setDataDispense({ ...dataDispense, deliveryBy: "freeSaleWithOrder" });
      }
    );
  };

  const renderComponent = () => {
    return (
      <div className="main-container ">
        <Flex
          mih={50}
          w={"100%"}
          gap="md"
          justify="start"
          align="center"
          direction="column"
          wrap="wrap"
          p={"xl"}
          data-testid="selectiondelivery-mainflex"
        >
          <Box className="self-start" data-testid="selectiondelivery-backbox">
            <Tooltip label="Regresar" withArrow position="right">
              <IconChevronLeft
                data-testid="selectiondelivery-gobackbutton"
                style={{ width: 35, height: 35 }}
                className="primary-color pointer "
                onClick={() => {
                  setDataDispense({ showDeliveryBy: false, orderId: null });
                }}
              />
            </Tooltip>
          </Box>
          <Title
            mb="sm"
            size={"h2"}
            c="secondary-color"
            fw={"bold"}
            data-testid="selectiondelivery-title"
          >
            Entrega de medicamentos
          </Title>
          <Group px="xl" justify="space-around" data-testid="selectiondelivery-group">
            <Card
              key={"insurance"}
              shadow="sm"
              padding="lg"
              radius="md"
              __size="xl"
              w={250}
              onClick={() => {
                navigate(routes.getDeliveryDispensation);
                setDataDispense({ ...dataDispense, deliveryBy: "insurance" });
              }}
              className="card"
              data-testid="selectiondelivery-card-insurance"
            >
              <div
                className="flex-column justify-center items-center cardSpace"
                data-testid="selectiondelivery-cardspace-insurance"
              >
                <div className="pinColor">
                  <IconMedicineSyrup
                    style={{
                      width: 30,
                      height: 30
                    }}
                    className="primary-color whiteHover"
                  />
                </div>
                <Text size="sm" mt={"sm"} fw="bold" className="primary-color ">
                  Aseguradora
                </Text>
              </div>
            </Card>
            <Card
              key={"particular"}
              shadow="sm"
              padding="lg"
              radius="md"
              __size="xl"
              w={250}
              onClick={() => void handleParticularDelivery()}
              className="card"
              data-testid="selectiondelivery-card-particular"
            >
              <div
                className="flex-column justify-center items-center cardSpace"
                data-testid="selectiondelivery-cardspace-particular"
              >
                <div className="pinColor">
                  <IconPills
                    style={{
                      width: 30,
                      height: 30
                    }}
                    className="primary-color"
                  />
                </div>
                <Text size="sm" mt={"sm"} fw="bold" className="primary-color">
                  Venta libre
                </Text>
              </div>
            </Card>
          </Group>
        </Flex>
      </div>
    );
  };

  return renderComponent();
}
